import React from 'react'
import find from 'lodash/find'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '_metronic/helpers'

const paymentStatusTypes = [
  {
    id: 'PAID',
    name: 'Paid',
    iconPath: 'payment_circle',
  },
  {
    id: 'PENDING',
    name: 'Unpaid',
    iconPath: 'payment_unpaid',
  },
  {
    id: 'PAYMENT_FAILED',
    name: 'Failed',
    iconPath: 'payment_unpaid',
  },
  {
    id: 'PARTIALLY_PAID',
    name: 'Partial Paid',
    iconPath: 'payment_circle_muted',
  },
  {
    id: 'PARTIALLY_REFUNDED',
    name: 'Partial Refund',
    iconPath: 'payment_circle_muted',
  },
  {
    id: 'REFUNDED',
    name: 'Refunded',
    iconPath: 'payment_circle_muted',
  },
]

interface Props {
  status: string
}

export const PaymentStatus: React.FC<Props> = ({status}) => {
  const payment = find(paymentStatusTypes, {id: status.toUpperCase()})
  if (payment) {
    return (
      <div className='d-flex align-items-center'>
        <SVG
          id={payment.id}
          src={toAbsoluteUrl(`/media/icons/corksy/${payment.iconPath}.svg`)}
          className='svg-icon-2hx me-3'
        />
        <div>{payment.name}</div>
      </div>
    )
  }
  return <div>{status}</div>
}

export default PaymentStatus
